export const personalData = {
    title: 'Личные сведения',
    isBordered: true,
    blocks: [
        {
            type: 'text',
            value: 'К личным сведениям посетителя сайта относятся вся информация, предоставляемая Вами нам при заполнении обязательных полей электронных форм, а именно:',
        },
        {
            type: 'list',
            items: [
                'имя пользователя;',
                'контактный электронный почтовый адрес e—mail;',
                'контактный телефон;',
                'любые другие данные, указанные Вами в сообщении.',
            ],
        },
    ],
};
